
export function onChangeHeaderLang(lan: string) {
	let routerHref: string = location.href.slice(0);
	const originHref = routerHref;
	routerHref = routerHref.replace(/(\/\w+\/active\/)|(\/active\/)/g, `/${lan}/active/`);
	if (originHref === routerHref) {
		location.reload();
	} else {
		location.replace(routerHref);
	}
}
